import React from 'react';
import { ChatMessage } from '@/api/chat';
import MessageBubble from './MessageBubble';
import MobileMessageBubble from './MobileMessageBubble';
import { Bot } from 'lucide-react';

interface MessageListProps {
  messages: ChatMessage[];
  loading?: boolean;
}

export default function MessageList({ messages, loading }: MessageListProps) {
  const scrollRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages, loading]);

  if (messages.length === 0 && !loading) {
    return (
      <div className="flex items-center justify-center h-full text-gray-400">
        <p>暂无消息，开始对话吧！</p>
      </div>
    );
  }

  return (
    <div ref={scrollRef} className="flex-1 overflow-y-auto p-2 md:p-4 space-y-3 md:space-y-4">
      {messages.map((message, index) => (
        <React.Fragment key={message.id}>
          {/* 移动端使用优化组件 */}
          <div className="md:hidden">
            <MobileMessageBubble 
              message={message} 
              isLast={index === messages.length - 1 && !loading}
            />
          </div>
          {/* 桌面端使用原组件 */}
          <div className="hidden md:block">
            <MessageBubble message={message} />
          </div>
        </React.Fragment>
      ))}
      {loading && (
        <div className="flex items-start gap-3 mt-4 px-2">
          <div className="flex-shrink-0 w-8 h-8 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
            <Bot className="w-5 h-5 text-blue-600 dark:text-blue-400" />
          </div>
          <div className="flex-1 space-y-3">
            <div className="text-sm font-medium text-blue-600 dark:text-blue-400">张雪峰AI</div>
            <div className="space-y-2">
              <div className="w-48 h-4 bg-gradient-to-r from-blue-100 to-blue-200 dark:from-blue-900/20 dark:to-blue-800/30 rounded animate-pulse" />
              <div className="w-32 h-4 bg-gradient-to-r from-blue-100 to-blue-200 dark:from-blue-900/20 dark:to-blue-800/30 rounded animate-pulse" />
              <div className="w-40 h-4 bg-gradient-to-r from-blue-100 to-blue-200 dark:from-blue-900/20 dark:to-blue-800/30 rounded animate-pulse" />
            </div>
            <div className="flex items-center space-x-1 text-xs text-gray-500 dark:text-gray-400">
              <span className="flex items-center gap-1">
                <div className="w-1.5 h-1.5 bg-blue-500 dark:bg-blue-400 rounded-full animate-pulse" />
                正在思考中
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
